// src/pages/registro/SeleccionRol.js
//
// Landing del registro. Dos opciones: veci o negocio. El domiciliario
// se afilia desde el negocio (no se auto-registra en el web).

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Card, CardContent, CardActionArea, Typography, Grid, Stack, Button,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Logo from '../../components/Logo';

export default function SeleccionRol() {
  const navigate = useNavigate();

  const opciones = [
    {
      rol: 'veci',
      titulo: 'Soy veci',
      descripcion: 'Vives en el barrio y quieres pedirle a las tiendas de tu cuadra.',
      icono: <PersonIcon sx={{ fontSize: 48, color: 'warning.main' }} />,
      path: '/registro/veci',
    },
    {
      rol: 'negocio',
      titulo: 'Soy tendero',
      descripcion: 'Tienes una tienda de barrio y quieres recibir pedidos por HolaVeci.',
      icono: <StorefrontIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/registro/negocio',
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FBF7F0', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="lg" sx={{ py: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button onClick={() => navigate('/')} startIcon={<ArrowBackIcon />}>Volver</Button>
        <Logo />
      </Container>

      <Container maxWidth="md" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', py: 6 }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="overline" color="text.secondary">Crear cuenta</Typography>
          <Typography variant="h3" sx={{ fontFamily: 'Fraunces', mb: 1 }}>
            ¿Cómo vas a usar HolaVeci?
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 4 }}>
            Elige el tipo de cuenta que necesitas. Puedes tener las dos con distintos teléfonos.
          </Typography>

          <Grid container spacing={3}>
            {opciones.map((op) => (
              <Grid item xs={12} md={6} key={op.rol}>
                <Card sx={{ height: '100%' }}>
                  <CardActionArea onClick={() => navigate(op.path)} sx={{ height: '100%', p: 3 }}>
                    <Stack spacing={2} alignItems="flex-start">
                      {op.icono}
                      <Typography variant="h5" sx={{ fontFamily: 'Fraunces' }}>{op.titulo}</Typography>
                      <Typography variant="body2" color="text.secondary">{op.descripcion}</Typography>
                    </Stack>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            ¿Ya tienes cuenta?{' '}
            <Button variant="text" onClick={() => navigate('/login')}>Inicia sesión</Button>
          </Typography>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
            ¿Eres domiciliario? Tu tendero debe pre-registrarte desde su cuenta y luego te llegará un mensaje para completar el registro desde tu celular.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
